/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";
import { NullOrEmpty } from "../utils"

export const getAutoP2PPayments = (query) => {
  // var {
  // } = query;

  return API.get(`${process.env.REACT_APP_API_URL}/api/autop2p/get`);
}

export const updateAutoP2PPayments = (payments) => {
  return API.post(`${process.env.REACT_APP_API_URL}/api/autop2p`, payments);
}

export const autoP2PService = {
  getAutoP2PPayments,
  updateAutoP2PPayments
};
